module.exports = __webpack_public_path__ + "media/images/emblems/Wapen_Lumnezia-e66f8a8dc1693e33749702db979754a7.gif";